import {
  type CoworkerAndTeamSelectionMode,
  type SelectCoworkerAndTeamModalDefinition,
  type TeamSelection,
} from "@repo/api";
import { getUserInfoFromEmail } from "@repo/utils";

import { Assigned } from "./AssignedCoworker";
import { type SelectCoworkerAndTeamModalProps } from "./SelectCoworkerAndTeamModal";

interface Props {
  selectionMode: CoworkerAndTeamSelectionMode;
  selected: TeamSelection | string[] | undefined;
  title?: string;
  required?: boolean;
  setSelected?: SelectCoworkerAndTeamModalProps["setSelected"];
  pushModal: (modalProps: SelectCoworkerAndTeamModalDefinition) => void;
  searchContext?: "PROJECT" | "CALENDAR";
}

export const CoworkerAndTeamSelectorListItem = ({
  selectionMode,
  selected,
  title,
  required,
  setSelected,
  pushModal,
  searchContext,
}: Props) => {
  const isTeam = selected && !Array.isArray(selected);
  const usersList = Array.isArray(selected)
    ? selected.map((email) => getUserInfoFromEmail(email))
    : isTeam
      ? selected.members.filter((m) => m.selected)
      : undefined;

  return (
    <Assigned
      assigned={usersList}
      assignedTeam={isTeam ? selected.team : undefined}
      title={title}
      onClick={() =>
        pushModal({
          type: "SELECT_TEAM_OR_COWORKER",
          selectionMode,
          selected: Array.isArray(selected)
            ? selected.map((email) => getUserInfoFromEmail(email))
            : selected,
          setSelected,
          searchContext,
        })
      }
      required={required}
    />
  );
};
